var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Core / Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMVP---Bank",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payments_06",
    transform: "translate(-664.000000, -256.000000)",
    fill: "#006AFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core-/-Edit",
    transform: "translate(658.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1567,8.6569 L15.3277,5.8279 L16.7417,4.4149 L19.5707,7.2429 L18.1567,8.6569 Z M6.8287,19.9849 L4.0017,19.9839 L4.0007,17.1569 L13.9137,7.2419 L16.7417,10.0709 L6.8287,19.9849 Z M21.6917,6.5349 L17.4487,2.2929 C17.0577,1.9029 16.4257,1.9029 16.0347,2.2929 L2.2927,16.0349 C2.1047,16.2219 1.9997,16.4769 2.00069292,16.7419 L2.0017,20.9839 C2.0017,21.5349 2.4487,21.9829 3.0017,21.9829 L7.2427,21.9849 C7.5077,21.9849 7.7617,21.8789 7.9497,21.6919 L21.6917,7.9499 C22.0827,7.5589 22.0827,6.9259 21.6917,6.5349 L21.6917,6.5349 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.a48396cd.svg";
export { ForwardRef as ReactComponent };